import sr from 'date-fns/locale/sr';

const DateTimeFormats = {
  sunday: 'Нед',
  monday: 'Пон',
  tuesday: 'Уто',
  wednesday: 'Сре',
  thursday: 'Чет',
  friday: 'Пет',
  saturday: 'Суб',
  ok: 'OK',
  today: 'Данас',
  yesterday: 'Јуче',
  now: 'Сада',
  hours: 'Сати',
  minutes: 'Минути',
  seconds: 'Секунде',
  /**
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   **/
  formattedMonthPattern: 'MMM yyyy',
  formattedDayPattern: 'dd MMM yyyy',
  shortDateFormat: 'dd/MM/yyyy',
  shortTimeFormat: 'HH:mm',
  dateLocale: sr as any,
};

const Combobox = {
  noResultsText: 'Нема резултата',
  placeholder: 'Изабери',
  searchPlaceholder: 'Претражи',
  checkAll: 'Све',
};

const CreatableComboBox = {
  ...Combobox,
  newItem: 'Нова ставка',
  createOption: 'Креирај опцију "{0}"',
};

export default {
  code: 'sr-SR',
  common: {
    loading: 'Учитавање...',
    emptyMessage: 'Нема података',
    remove: 'Уклони',
    clear: 'Обриши',
  },
  Plaintext: {
    unfilled: 'Непопуњено',
    notSelected: 'Није изабрано',
    notUploaded: 'Није учитано',
  },
  Pagination: {
    more: 'Више',
    prev: 'Претходна',
    next: 'Следећа',
    first: 'Прва',
    last: 'Последња',
    limit: '{0} / страна',
    total: 'Укупно редова: {0}',
    skip: 'Иди на {0}',
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: 'Последњих 7 дана',
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: 'Иницијално',
    progress: 'Учитавање',
    error: 'Грешка',
    complete: 'Завршено',
    emptyFile: 'Празно',
    upload: 'Учитај',
    removeFile: 'Уклони фајл',
  },
  CloseButton: {
    closeLabel: 'Затвори',
  },
  Breadcrumb: {
    expandText: 'Прикажи путању',
  },
  Toggle: {
    on: 'Отворено',
    off: 'Затворено',
  },
};
